import LCC from 'lightning-container';

// const getLearnWorldsSSOurlRemoting = (redirectUrl) => {
//   return new Promise(async (resolve, reject) => {
//     await LCC.callApex(
//       'NCADashboardHomeController.getLearnWorldsSSOurl',
//       redirectUrl,
//       (result, event) => {
//         if (isTimeOut(result)) {
//           return
//         }
//         if (event.status) {
//           resolve(result);
//         } else if (event.type === 'exception') {
//           reject(event.message);
//         } else {
//           reject(event.message);
//         }
//       }, {
//         escape: true
//       }
//     );
//   });
// }

const initializeRedirectUrlRemoting = (jsonParams) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex(
      'NCADashboardHomeController.initializeRedirectUrl',
      jsonParams,
      (result, event) => {
        if (isTimeOut(result)) {
          return
        }
        if (event.status) {
          resolve(result);
        } else if (event.type === 'exception') {
          reject(event.message);
        } else {
          reject(event.message);
        }
      }, {
        escape: true
      }
    );
  });
}

const sfdcRemoting = () => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex(
      'NCADashboardHomeController.initNCADashboardHome',
      (result, event) => {
        if (isTimeOut(result)) {
          return
        }
        if (event.status) {
          const ncaDashboardHomeData = JSON.parse(result.replaceAll('&quot;', '"').replaceAll('&amp;', '&').replaceAll('&#39;', '\''));
          resolve(ncaDashboardHomeData);
        } else if (event.type === 'exception') {
          reject(event.message);
        } else {
          reject(event.message);
        }
      }, {
        escape: true
      }
    );
  });
}

const startScholarshipApplicationRemoting = (source, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex(
      'NCADashboardHomeController.startScholarshipApplication',
      source,
      userId,
      (result, event) => {
        if (isTimeOut(result)) {
          return
        }
        if (event.status) {
          resolve(result);
        } else if (event.type === 'exception') {
          reject(event.message);
        } else {
          reject(event.message);
        }
      }, {
        escape: true
      }
    );
  });
}

const startClientApplicationBySourceRemoting = (source, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex(
      'NCADashboardHomeController.startClientApplicationBySource',
      source,
      userId,
      (result, event) => {
        if (isTimeOut(result)) {
          return
        }
        if (event.status) {
          resolve(result);
        } else if (event.type === 'exception') {
          reject(event.message);
        } else {
          reject(event.message);
        }
      }, {
        escape: true
      }
    );
  });
}

const getViewLoansRemoting = (userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex(
      'NCADashboardHomeController.getViewLoans',
      userId,
      (result, event) => {
        if (isTimeOut(result)) {
          return
        }
        if (event.status) {
          const viewLoanOfContactData = JSON.parse(result.replaceAll('&quot;', '"').replaceAll('&amp;', '&'));
          resolve(setLoanErroPopup(viewLoanOfContactData));
        } else if (event.type === 'exception') {
          reject(event.message);
        } else {
          reject(event.message);
        }
      }, {
        escape: true
      }
    );
  });
}
const setLoanErroPopup = (viewLoanOfContactData) => {
  let loanErrorPopup = {isShow: false, loanStatus: ''};
  viewLoanOfContactData.map(row => {
    let isSetLoanErrorPopup = false;
    if (row.programType === 'IFRP Credit-Building Loan') {
      if (row.loanStatus === 'Charge Off') {
        isSetLoanErrorPopup = true;
      } else if (row.loanPaymentTransactions.length < 3 && row.loanStatus.indexOf('Closed:') < 0) {
        isSetLoanErrorPopup = true;
      }
    } else {
      if (row.loanStatus === 'Active: Good Standing') {
        if (row.todayToMaturityDate >= 30 && row.loanBalance > 0) {
          isSetLoanErrorPopup = true;
        }
      } else if (row.loanStatus.indexOf('Past Due') > -1 || row.loanStatus === 'Charge Off') {
        isSetLoanErrorPopup = true;
      }
    }
    if (isSetLoanErrorPopup) {
      loanErrorPopup.isShow = true;
      loanErrorPopup.loanStatus = row.loanStatus;
    }
  })
  return loanErrorPopup;
}

const getPlaidLinkToken = (source, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.fetchLinkToken', source, userId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const autoVerifyPlaidInfo = (source, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.autoVerifyPlaidInfo', source, userId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const getAuth = (institutionName, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.getAuth', institutionName, userId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const submitPlaidInfo = (source, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.submitPlaidInfo', source, userId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const checkAccountSubmit = (params, userId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.checkAccountSubmit', params, userId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const uploadFileToFile = (params) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.uploadFileToFile', params, (result, event) => {
      if (isTimeOut(result)) {
        return;
      }
      if (event.status) {
        resolve(result);
      } else {
        reject(event);
      }
    }, {
      escape: true
    });
  });
}

const deleteFileFromFile = (attachmentId) => {
  return new Promise(async (resolve, reject) => {
    await LCC.callApex('NCADashboardHomeController.deleteFileFromFile', attachmentId, (result, event) => {
      if (isTimeOut(result)) {
        return
      }
      if (event.status) {
        resolve(result)
      } else if (event.type === 'exception') {
        reject(event.message);
      } else {
        reject(event.message);
      }
    }, {
      escape: true
    })
  })
}

const isTimeOut = (result) => {
  if (result && result.indexOf('TimeOut') !== -1) {
    window.VueStore.commit('TIME_OUT', true);
    window.VueStore.commit('IS_CUSTOM_POPUP_CHANGED', true);
    window.VueStore.state.isLoading = false;
    return true;
  }
  return false;
}

const openSurveyByLanguage = (retProgramEligibilityUrls, contactId) => {
  if (!retProgramEligibilityUrls || !retProgramEligibilityUrls.length) {
    console.warn('No program eligibility URLs available.');
    return;
  }

  const langMap = {
    en: 'English',
    es: 'Spanish',
    zh: 'Chinese',
    tl: 'Tagalog'
  };

  const currentLangCode = window.CurrentDisplayedLanguage || 'en';
  const currentLangName = langMap[currentLangCode.toLowerCase()] || 'English';

  let surveyUrlObj = retProgramEligibilityUrls.find(
    (item) => item.Language__c === currentLangName
  );

  if (!surveyUrlObj) {
    surveyUrlObj = retProgramEligibilityUrls.find(
      (item) => item.Language__c === 'English'
    );
  }

  if (surveyUrlObj && surveyUrlObj.Survey_URL__c) {
    window.open(surveyUrlObj.Survey_URL__c + '?contactId=' + contactId, '_self');
  } else {
    console.warn('Survey URL not found for language:', currentLangName);
  }
};

export {
  sfdcRemoting,
  startScholarshipApplicationRemoting,
  startClientApplicationBySourceRemoting,
  getViewLoansRemoting,
  setLoanErroPopup,
  getPlaidLinkToken,
  autoVerifyPlaidInfo,
  getAuth,
  submitPlaidInfo,
  checkAccountSubmit,
  uploadFileToFile,
  deleteFileFromFile,
  initializeRedirectUrlRemoting,
  // getLearnWorldsSSOurlRemoting,
  openSurveyByLanguage,
};
export default {};



// WEBPACK FOOTER //
// ./src/api/sfdc-remoting.js